import React, { FC, useCallback } from 'react';
import type { ILegoElemProps } from '../../Lego';
import { DatePicker } from '../../../../atoms/DatePicker';
import { useLegoFormContext } from '../../_FormProvider/useLegoFormContext';
import { ILegoElemDatePicker } from '../models';

export const LegoElemDatePicker: FC<ILegoElemProps> = ({ elem, loading, errorMessage }) => {
  const { formHook } = useLegoFormContext();
  const value = formHook.watch(elem.id);
  const datePickerElem = elem as ILegoElemDatePicker;

  const handleOnChange = useCallback(
    (val: string | string[] | null | (null | string)[]) => {
      formHook.setValueAndRevalidate(elem.id, val === '' ? undefined : val);
    },
    [elem.id, formHook],
  );

  return (
    <DatePicker
      {...datePickerElem.datePicker}
      id={elem.id}
      value={value}
      onChange={handleOnChange}
      isHelpMessage
      errorMessage={errorMessage}
      disabled={datePickerElem.datePicker.disabled ? true : loading}
    />
  );
};
